<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__legal_entity><div class="table-default__left">Legal entity</div></template>
      <template #h__tax><div class="table-default__left">Tax</div></template>
      <template #legal_entity="{ row }"><div class="table-default__left">{{ row.legal_entity.name }}</div></template>
      <template #tax="{ row }">
        <div class="table-default__left table-default__controls">
          <div
            v-tooltip="{ content: row.notes, placement: 'top-start', offset: 10 }"
            class="table-default__activity table-default__activity--notes"
            :class="{'table-default__activity--active': row.notes}"
          />
          <router-link :to="{name: 'finance-taxes-detail', params: {id: row.id }}" class="table-default__link-border">
            {{ row.tax.name_expense }} ({{ dateFormatMonth(row.accounting_date) }})
          </router-link>
        </div>
      </template>
      <template #date="{ row }">{{ dateFormat(row.date) }}</template>
      <template #amount="{ row }">{{ amountFormat(row.amount) }}</template>
      <template #attachment="{ row }">
        <a
          :class="{'table-default__disabled': !row.attachment}"
          :href="row.attachment?.file"
          target="_blank"
        >
          <img alt="Attachment" src="@/assets/img/snacks-link.svg">
        </a>
      </template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableListInvoice',
  props: ['tableItems', 'tablePreloader', 'pagination', 'dateFormat', 'dateFormatMonth', 'amountFormat'],
  data() {
    return {
      table: {
        columns: ['legal_entity', 'tax', 'date', 'amount', 'attachment'],
        options: {
          headings: {
            'legal_entity': 'Legal entity',
            'tax': 'Tax',
            'date': 'Date',
            'amount': 'Amount',
            'attachment': 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
}
</script>

